module.exports = __webpack_public_path__ + "static/media/instagram.52d5181d.svg";